import {
  ADMIN_SERVLET_URL,
  DELETE_SUB_ACCOUNT_URL,
  ERROR_LIST_OPTIONS_URL,
  LOAD_PRICE_URL,
  LOAD_SUB_ACCOUNT_URL,
  MANAGE_USERS_URL,
  SAVE_PRICE_URL,
  SAVE_SUB_ACCOUNT_URL,
  USER_URL,
  USER_SERVLET_URL,
} from 'consts/api';
import services, { HeaderUTF8Option } from 'services';
import QueryString from 'query-string';
import { IsJsonString } from 'helpers';
import { SecurityConst } from 'consts/data';
import isEmpty from 'lodash/isEmpty';

export const keyCachedUsers = 'cachedUsers';
export const keyRootUser = 'rootUser';

class UserServices {
  constructor() {
    this.userInfo = null;
  }

  setUserInfoToStorage(userInfo) {
    this.userInfo = userInfo;
  }

  getRootUser() {
    return localStorage.getItem(keyRootUser);
  }

  setRootUser(email) {
    localStorage.setItem(keyRootUser, email);
  }

  clearUserCached() {
    localStorage.removeItem(SecurityConst.authStorage);
    localStorage.removeItem('rootUser');
    localStorage.removeItem('usersLogged');
    // localStorage.removeItem('theme');
  }

  getCachedUser() {
    return localStorage.getItem(keyCachedUsers) &&
      IsJsonString(localStorage.getItem(keyCachedUsers))
      ? JSON.parse(localStorage.getItem(keyCachedUsers))
      : undefined;
  }

  updateCachedUser(user) {
    if (isEmpty(user)) {
      return;
    }

    localStorage.setItem(keyCachedUsers, JSON.stringify(user));
  }

  /**
   *
   * @returns {{
   *  jwt: string
   * }}
   */
  getJWTAuth() {
    const jwtStringify = localStorage.getItem(SecurityConst.authStorage) || '';
    if (IsJsonString(jwtStringify)) {
      return JSON.parse(jwtStringify);
    }

    return null;
  }

  updateManageUser(body = {}) {
    const nextBody = { ...body };
    nextBody.action = 'updateUserInfo';

    return services.post(MANAGE_USERS_URL, QueryString.stringify(nextBody), HeaderUTF8Option);
  }

  getUserServlet() {
    return services.post(USER_URL);
  }

  loadPriceTable(email = '') {
    return services.get(`${LOAD_PRICE_URL}?email=${encodeURIComponent(email)}`);
  }

  savePriceTable({ email = '', body = [] }) {
    return services.post(`${SAVE_PRICE_URL}?email=${encodeURIComponent(email)}`, body);
  }

  loadSubAccount(username = '') {
    return services.get(`${LOAD_SUB_ACCOUNT_URL}?username=${encodeURIComponent(username)}`);
  }

  saveSubAccount({ username = '', body }) {
    return services.post(`${SAVE_SUB_ACCOUNT_URL}?username=${encodeURIComponent(username)}`, body);
  }

  deleteSubAccount(key = '') {
    return services.delete(`${DELETE_SUB_ACCOUNT_URL}?key=${key}`);
  }

  getListUser({ action, filters }) {
    const {
      searchFilters,
      searchValues,
      sortDirections,
      sortFields,
      pageSize,
      page,
      userStatuses,
      operator,
    } = filters;
    return services.post(
      MANAGE_USERS_URL,

      QueryString.stringify({
        action,
        'sortFields[]': sortFields,
        'sortDirections[]': sortDirections,
        'searchFilters[]': searchFilters,
        'searchValues[]': searchValues,
        operator,
        pageSize,
        page,
        userStatuses,
      }),
    );
  }

  getTotalListUser({ action, filters }) {
    const { searchFilters, searchValues, pageSize, page, userStatuses, operator } = filters;
    return services.post(
      MANAGE_USERS_URL,
      QueryString.stringify({
        action,
        'searchFilters[]': searchFilters,
        'searchValues[]': searchValues,
        pageSize,
        page,
        userStatuses,
        operator,
      }),
    );
  }

  searchUser(searchValue) {
    return services.post(
      MANAGE_USERS_URL,
      QueryString.stringify({
        action: 'searchBySelectedField',
        'searchValues[]': searchValue,
        'searchFilters[]': 'username_email',
        dummyValue: 'skip it',
      }),
    );
  }

  createUser({ dataUser, action }) {
    const body = QueryString.stringify({
      action,
      ...dataUser,
    });

    return services.post(MANAGE_USERS_URL, `${body}`, HeaderUTF8Option);
  }

  cloneUser({ dataUser, action }) {
    return services.post(
      MANAGE_USERS_URL,
      QueryString.stringify({
        action,
        ...dataUser,
      }),
      HeaderUTF8Option,
    );
  }

  deleteUser({ action, emails }) {
    return services.post(
      ADMIN_SERVLET_URL,
      QueryString.stringify({
        action,
        emails,
      }),
    );
  }

  updateSetting(body) {
    return services.post(USER_SERVLET_URL, QueryString.stringify(body), HeaderUTF8Option);
  }

  addCredit({ action, useremail, type, noOfTexts }) {
    return services.post(
      ADMIN_SERVLET_URL,
      QueryString.stringify({
        action,
        useremail,
        type,
        noOfTexts,
      }),
    );
  }

  showDid(body) {
    return services.post(MANAGE_USERS_URL, QueryString.stringify(body));
  }

  regenerateApiKey(email = '') {
    return services.post(
      MANAGE_USERS_URL,
      QueryString.stringify({
        action: 'updateApiKey',
        email,
      }),
      HeaderUTF8Option,
    );
  }

  updateClickFilter(body) {
    return services.post(`${USER_SERVLET_URL}?action=updateClickFilter`, body);
  }

  getUserStatusEnum() {
    return services.post(
      MANAGE_USERS_URL,
      QueryString.stringify({
        action: 'getUserStatusEnum',
      }),
    );
  }

  revokeAllTokens(body) {
    return services.post(
      ADMIN_SERVLET_URL,
      QueryString.stringify({
        action: 'revokeAllTokens',
        ...body,
      }),
    );
  }

  deleteAllRevokeTokens(body) {
    return services.post(
      ADMIN_SERVLET_URL,
      QueryString.stringify({
        action: 'deleteAllRevokedTokens',
        ...body,
      }),
    );
  }

  deleteAllTokens(body) {
    return services.post(
      ADMIN_SERVLET_URL,
      QueryString.stringify({
        action: 'deleteAllTokens',
        ...body,
      }),
    );
  }

  changeLayoutMonitoring(campaignMonitoringLayout = []) {
    return services.post(
      USER_SERVLET_URL,
      QueryString.stringify({
        action: 'updateCampaignMonitoringLayout',
        campaignMonitoringLayout: JSON.stringify(campaignMonitoringLayout),
      }),
    );
  }

  getErrorList() {
    return services.get(ERROR_LIST_OPTIONS_URL);
  }

  getUserInfo() {
    return services.post(USER_SERVLET_URL);
  }
}

export default new UserServices();
